<template>
	<div>
		<xl-dialog v-model="uninstallDialog" width="320px" :center="true" top="50vh">
			<div class="print-out-img">
				<img v-if="info.softwareName === 'accuware'" src="../../assets/image/activeprint1.png" alt="" class="print-out"/>
			</div>
		<div class="title">{{ $t("user.case.testSoft") }}</div>
			<div v-if="info.softwareName === 'accuware'" class="content">{{ $t("user.case.testSoftTip") }}</div>
			<div v-else-if="info.softwareName === 'splint'" class="content">{{ $t("cloudSplint.downloadSplintTip") }}</div>
			<div class="footer">
				<xl-button class="footer-button" @click="uninstallDialog=false">{{ $t( 'button.cancel' ) }}</xl-button>
				<xl-button type="primary"  class="footer-button" @click="handleToDownload">{{ $t( 'user.case.toDownload' ) }}</xl-button>
			</div>
		</xl-dialog>
	</div>
</template>

<script setup>
import { XlDialog, XlButton } from '@shining3d/ui-components';
import { ref, defineExpose } from 'vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { $openUrl } from '../../utils/common.js';
import _get from 'lodash/get'

const { $t } = useLang( '@shining3d/app' );

const uninstallDialog = ref( false );
const info = ref({});

const handleToDownload = () => {
	$openUrl( _get( window, 'app.global.toDownLoad' ));
};

const open = ( data ) => {
	uninstallDialog.value = true;
	info.value = { ...data }
}

defineExpose({ open });

</script>

<style scoped lang="scss">
:deep(.xl-dialog.el-dialog){
	--el-dialog-border-radius: 8px;
	transform: translateY(-50%);
}

:deep(.el-dialog__header){
display:none!important;
}

:deep(.el-dialog__body){
	margin:0!important;
	padding:20px 24px !important;
}

:deep(.el-dialog){
 min-width:320px
}
.print-out-img{
	width: 100%;
	height: 76px;
	margin-top: 20px;
}
.print-out{
	width: 62px;
	height: 76px;
	margin-left: 103px
}
.title{
	width: 100%;
	height: 26px;
	font-size: 18px;
	font-family: AlibabaPuHuiTi_2_85_Bold;
	color: #2C364E;
	line-height: 26px;
	text-align: center;
	margin: 7px 0 3px 0;
}
.content{
	width: 100%;
	height: 127px;
	font-size: 14px;
	font-family: AlibabaPuHuiTi_2_55_Regular;
	color: #42526E;
	line-height: 20px;
	text-align: center;
}
.footer{
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: space-between;
	.footer-button{
		width: 132px;
		height: 40px;
	}
}
</style>
